import { motion } from "framer-motion";

// Masked line reveal — text slides up from behind an overflow mask.
// animateOnMount: play on page load (hero); otherwise reveal on scroll into view.
export const MaskedLine = ({
  children,
  delay = 0,
  duration = 1.1,
  className = "",
  innerClassName = "",
  animateOnMount = false,
}) => {
  const motionProps = animateOnMount
    ? { initial: { y: "115%" }, animate: { y: "0%" } }
    : {
        initial: { y: "115%" },
        whileInView: { y: "0%" },
        viewport: { once: true, margin: "-40px" },
      };

  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className={`block will-change-transform ${innerClassName}`}
        {...motionProps}
        transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};
